export const APPROVED_HANDLE_ID: string = 'APPROVED'
export const APPROVED_HANDLE_LABEL: string = 'Approved'

export const REJECTED_HANDLE_ID: string = 'REJECTED'
export const REJECTED_HANDLE_LABEL: string = 'Rejected'
